import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "beneficial-ownership-submission")!;
const BeneficialOwnershipSubmission = () => <ServicePageTemplate data={data} />;
export default BeneficialOwnershipSubmission;
